import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { startImpersonation } from "../../auth/impersonation";
import AuthFrame from "../auth/v2/AuthFrame";
import { TitleBlock, Note, Actions, PrimaryBtn, SecondaryBtn } from "../auth/v2/pieces";
import { Loading } from "../ForBrands/ui/BrandUI";

export const MISSING_SESSION = "This link is missing its session. Open the user again from the Users page.";
export const SESSION_NOT_STORED = "This tab could not keep the user's session. Open the user again from the Users page.";

// /admin/impersonate#access=...&email=...  (opened in a new tab by the
// Users page). Stores the session for this tab only and reloads as the user.
// It sits on the V2 auth frame: a quiet loading line while it works, and a
// short error with a way out when the link has no usable session.
const ImpersonateLanding = () => {
  const navigate = useNavigate();
  const [error, setError] = useState("");
  useEffect(() => {
    const params = new URLSearchParams((window.location.hash || "").replace(/^#/, ""));
    const access = params.get("access");
    const email = params.get("email");
    if (!access || !email) {
      setError(MISSING_SESSION);
      return;
    }
    try {
      startImpersonation({
        access,
        email,
        name: params.get("name") || email,
        permissions: (params.get("permissions") || "").split(",").filter(Boolean),
        impersonatedBy: params.get("impersonatedBy") || "",
        expiresInSeconds: Number(params.get("expiresInSeconds") || 0) || undefined,
      });
    } catch (e) {
      // Storage blocked or full: the tab cannot hold the session.
      setError(SESSION_NOT_STORED);
    }
  }, []);
  return (
    <AuthFrame phoneLogo>
      {error ? (
        <>
          <TitleBlock tone="critical" eyebrow="Admin view" title="This user view could not open" />
          <div role="alert">
            <Note>{error}</Note>
          </div>
          <Actions>
            {/* The tab was opened by script from the Users page, so the
                browser lets it close itself. */}
            <PrimaryBtn onClick={() => window.close()}>Close this tab</PrimaryBtn>
            <SecondaryBtn onClick={() => navigate("/login")}>Go to log in</SecondaryBtn>
          </Actions>
        </>
      ) : (
        <Loading label="Opening the app as this user..." />
      )}
    </AuthFrame>
  );
};

export default ImpersonateLanding;
